<table class="table dataTable" ngClass="{{config.className || ''}}" role="grid" style="width: 100%;">
    <col *ngIf="config.selectable">
    <col *ngFor="let column of columns" style.width="{{column.width}}">
    <thead>
        <tr role="row">
            <th *ngIf="config.selectable || showResetFiltersButton">
                <div *ngIf="config.selectable" class="custom-control">
                    <input type="checkbox" class="form-check-input" (click)="onAllSelectionClick($event)">
                </div>
            </th>
            <th *ngFor="let column of columns" [ngTableSorting]="config" [column]="column"
                (sortChanged)="onChangeTableSort($event)" ngClass="{{column.className || ''}}">
                {{column.title}}
                <i *ngIf="config && column.sort" class="pull-right fa"
                    [ngClass]="{'fa-chevron-down': column.sort === 'desc', 'fa-chevron-up': column.sort === 'asc'}"></i>
            </th>
        </tr>
    </thead>
    <tbody>
        <tr *ngIf="showFilterRow">
            <td *ngIf="config.selectable || showResetFiltersButton">
                <button *ngIf="showResetFiltersButton" type="button" class="btn btn-light" (click)="onResetFilters()" tooltip="Reset all filters">
                    <span class="fa fa-undo"></span>
                </button>
            </td>
            <td *ngFor="let column of columns">
                <div *ngIf="column.filtering">
                    <input *ngIf="column.filtering.filterType == 'text'"
                        placeholder="{{column.filtering.placeholder}}" 
                        ngTableFiltering
                        [config]="column.filtering"
                        class="form-control" 
                        (tableChanged)="onChangeTable(config)"
                    />

                    <select *ngIf="column.filtering.filterType == 'select'"
                        ngTableFiltering
                        [config]="column.filtering" 
                        class="form-control"
                        (tableChanged)="onChangeTable(config)">
                        <option value="">All</option>
                        <option *ngFor="let item of column.filtering.filterData" value="{{item}}">{{item}}</option>
                    </select>

                    <div *ngIf="column.filtering.filterType == 'daterange'" class="input-group">
                        <input type="text" 
                            ngTableFiltering
                            [config]="column.filtering"
                            placeholder="{{column.filtering.placeholder}}" class="form-control"
                            (tableChanged)="onChangeTable(config)" bsDaterangepicker
                            [minDate]="column.filtering.minDate" [maxDate]="column.filtering.maxDate"
                            [(ngModel)]="column.filtering.bsRangeValue">
                        <div class="input-group-append">
                            <div class="input-group-append" (click)="onResetDateRangeFilter(column)">
                                <div class="input-group-text"><span class="fa fa-undo"></span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </td>
        </tr>
        <!-- <tr *ngFor="let row of rows; let i = index" [style.border-style]="selectedRow === i ? 'solid' : ''"> -->
        <tr *ngFor="let row of rows; let i = index">
            <td *ngIf="config.selectable  || showResetFiltersButton" (click)="cellClick(row, -1)">
                <div *ngIf="config.selectable" class="custom-control">
                    <input type="checkbox" 
                    class="form-check-input" 
                    [(ngModel)]="row.selected"
                    (ngModelChange)="itemModelChange($event)" >
                </div>
            </td>
            <td *ngFor="let column of columns"
                [innerHtml]="column.type === 'date' ? (sanitize(getData(row, column.name) | string2date :'short')) : sanitize(getData(row, column.name))"
                ngClass="{{column.cellClassName || ''}}"
                (click)="cellClick(row, column)"
                tooltip="{{column.toolTipProperty ? getData(row, column.toolTipProperty) : null}}" 
                container="td"
            ></td>
        </tr>
    </tbody>
</table>

<pagination *ngIf="config.paging" class="pagination-sm" [(ngModel)]="page" [totalItems]="length"
    [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true" [rotate]="false"
    (pageChanged)="onChangeTable(config, $event)" (numPages)="numPages = $event">
</pagination>

<div *ngIf="config.paging" class="card card-block card-header">
    <nav class="navbar navbar-expand-md p-0">
        <div class="collapse navbar-collapse">
            <span class="mr-auto mb-0">Page: {{page}} / {{numPages}}</span>
            <label class="mr-2 mb-0" for="items-per-page">Items per page</label>
            <input id="items-per-page" type="number" class="form-control w-auto" min="1" max="{{length}}"
                [(ngModel)]="itemsPerPage" (ngModelChange)="onChangeTable(config)" />
        </div>
    </nav>
</div>